
    import { Component, Vue } from 'vue-property-decorator';
    import { mapActions, mapMutations, mapState } from 'vuex';
    import RezepteDetail from '@/components/Rezepte/RezepteDetail.vue';
    import Rezept from '@/types/Rezept';
    import { LoadRezeptePayload, RezepteFilter } from '@/store/rezepte';
    import { DataTableHeaders } from '@/types';

    @Component({
        components: {
            RezepteDetail,
        },
        computed: {
            ...mapState('rezepte', ['rezepte', 'dialogs', 'loaders']),
        },
        methods: {
            ...mapActions('rezepte', ['loadRezepte', 'updateRezept']),
            ...mapMutations('rezepte', ['setDialogsDetail']),
        },
    })
    export default class Rezepte extends Vue {
        public loadRezepte!: (payload?: LoadRezeptePayload) => void;
        public setDialogsDetail!: (visible: boolean) => void;

        public rezept = new Rezept();
        public search = '';

        public filter: RezepteFilter = {
            gueltig: 'j',
        };

        public get headers(): DataTableHeaders<Rezept> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Bezeichnung', value: 'bezeichnung' },
                /*{ text: 'Verabreichung', value: 'verabreichung' },*/
                { text: 'Gültig', value: 'gueltig' },
            ];
        }

        public mounted(): void {
            this.loadRezepte();
        }

        public onChangeFilter(): void {
            this.loadRezepte({ filter: this.filter });
        }

        public onClickEdit(rezept: Rezept): void {
            this.rezept = new Rezept(rezept);
            this.setDialogsDetail(true);
        }

        public onClickNew(): void {
            this.rezept = new Rezept();
            this.setDialogsDetail(true);
        }
    }
